import {
  ScenarioSettingsParameters,
  ScenarioSettings as TScenarioSettings,
} from '@/store/types';
import { Parameters } from '../Parameters';
type TSetParameters = {
  form: TScenarioSettings;
  setForm: React.Dispatch<React.SetStateAction<TScenarioSettings>>;
};

/**
 * SetParameters Component
 * Renders a list of Parameters components for each parameter set in the form
 * Passes down the form state and setForm function to each Parameters component
 * @param {TSetParameters} props - The properties for the SetParameters component
 */
const SetParameters = ({ form, setForm }: TSetParameters) => {
  return (
    <div style={{ marginBottom: 80, paddingTop: 5 }}>
      {form.parameters.map(
        (item: ScenarioSettingsParameters, index: number) => (
          <div key={index}>
            {/*  {index} - CAT: {item.DropDown_JobsPrioritisation} */}
            <Parameters
              parameters={item}
              options={form.options}
              setForm={setForm}
              parameterIndex={index}
              totalSetParameters={form.parameters.length}
              runSeparated={form.run_separated}
            />
          </div>
        ),
      )}
    </div>
  );
};

export default SetParameters;
